import { MenuItem, Paper, TextField, Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { ICheckpoint } from '../../../models/IEvent';
import IEventBaseDataProps from './IEventBaseDataProps';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        table: {
            minWidth: 280,
        },
        root: {
            width: '100%',
        },
        paper: {
            width: '100%',
            marginBottom: theme.spacing(2),
        },
    }));

interface IEventReadersData {
    checkpoints: ICheckpoint[];
    readers: string[];
}
export default function EventReaders(props: IEventBaseDataProps<IEventReadersData>) {
    const classes = useStyles();
    const { t } = useTranslation("common");
    const data = props.data;


    const triggerDataChange = (newData: IEventReadersData) => {
        if (props.onDataChange) {
            props.onDataChange(newData);
        }
    }

    return (<Fragment>
        <Paper className={classes.paper}>
            <TextField
                id="checkpoints"
                select
                label={t("eventsetup.checkpoints")}
                value={props.data.checkpoints.length > 0 ? props.data.checkpoints[0].readerId : ""}
                onChange={e => {
                    if (e.target.value.length > 0) {
                        triggerDataChange({
                            ...data,
                            checkpoints: [{
                                readerId: e.target.value
                            }]
                        });
                    }
                }}
                helperText={t("eventsetup.checkpointshelper")}
            >
                {data.readers.map((reader) => (
                    <MenuItem
                        key={reader}
                        value={reader}>
                        {reader}
                    </MenuItem>
                ))}
            </TextField>
        </Paper>
    </Fragment>);
}